<div class="container">
  <div class="row">
    <div class="col-sm-12">
      <h1 class="main-heading">{{ 'rpe.vista-datos-mi-empresa.title' | translate }}</h1>
    </div>
  </div>
  <mat-card>
    <mat-card-content>
      <div class="back-url">
        <button mat-flat-button color="primary" [routerLink]="backUrl">Volver</button>
      </div>
      <div class="integrantes-info" *ngIf="!showIntegrantes">
        <ul>
          <ng-container *ngFor="let integrante of integrantes; let i = index">
            <li class="integrantes-list" *ngIf="+integrante.rol.estado_id !== 3">
              <div class="items">
                <div class="item">
                  <span>Nombre Completo: </span>
                  <span>{{integrante.nombre_completo}}</span>
                </div>
                <div class="item">
                  <span>Rol: </span>
                  <span>
                    {{ findRol(integrante.rol.tipo_rol_id) ?
                    findRol(integrante.rol.tipo_rol_id).nombre : 'No se encontro el rol' }}
                  </span>
                </div>
                <div class="item">
                  <span>Estado: </span>
                  <span [ngClass]="+integrante.rol?.estado_id === 1 ? 'red' : ''">
                    {{ findRolState(+integrante.rol?.estado_id) ?
                    findRolState(+integrante.rol?.estado_id) : 'No se encontro el rol' }}
                  </span>
                </div>
                <div class="item-lab" *ngIf="integrante.rol.tipo_rol_id === 7">
                  <span>Laboratorios:</span>
                  <ul>
                    <li class="lab-li" *ngFor="let lab of buscarLaboratoriosById(integrante.rol.laboratorios_id)">
                      {{ lab.nombre }}
                    </li>
                  </ul>
                </div>
              </div>
              <div class="options">
                <rpe-ui-button [bg_blue]="true" *ngIf="!isCreadorEmpresa(integrante.rol.persona_id)"
                  (onClick)="deleteIntegrante(integrante)">Eliminar integrante</rpe-ui-button>

                <rpe-ui-button (onClick)="updateIntegrante(integrante)" [bg_blue]="true">Modificar
                  integrante</rpe-ui-button>

                <rpe-ui-button [bg_blue]="true" *ngIf="integrante.rol.tipo_rol_id === 7"
                  [routerLink]="'/empresas/mis-actividades'">Modificar laboratorios</rpe-ui-button>
              </div>
            </li>
          </ng-container>
        </ul>
        <button mat-flat-button color="primary" (click)="showIntegrantes = !showIntegrantes">Agregar</button>
      </div>
      <div *ngIf="showIntegrantes">
        <rpe-registro-integrante-form [personaJuridica]="createdPersonaJuridica" [personaFisica]="createdPersonaFisica"
          (onCancel)="showIntegrantes = !showIntegrantes" [laboratorios]="laboratorios"
          [naturalezasJuridicas]="naturalezasJuridicas"></rpe-registro-integrante-form>
      </div>
    </mat-card-content>
  </mat-card>
</div>